


























import axios from 'axios';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Login extends Vue {
    public user: string = '';
    public password: string = '';
    public errorMessage: string = '';
    public busy: boolean = false;

    public async onSubmit(): Promise<void> {
        if (this.busy === true) {
            return;
        }
        this.errorMessage = '';
        this.busy = true;
        try {
            await axios.post('./api/login', { user: this.user, password: this.password });
            const redirect = (this.$route.query.redirect as string) || '/';
            await this.$router.replace(redirect);
            // ログイン後はチャネル等の初期データを取り直すため一度リロード
            window.location.reload();
        } catch (err: any) {
            const status = err?.response?.status;
            if (status === 401) {
                this.errorMessage = 'ユーザー名またはパスワードが違います';
            } else {
                this.errorMessage = `ログインに失敗しました (${status ?? 'network error'})`;
            }
        } finally {
            this.busy = false;
        }
    }
}
